/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosports2ColumnBannersData } from './hosports-2-column-banners.data';
import { IHosports2ColumnBannersProps } from './hosports-2-column-banners.props.autogenerated';

export interface IHosports2ColumnBannersViewProps extends IHosports2ColumnBannersProps<IHosports2ColumnBannersData> {

}

/**
 *
 * Hosports2ColumnBanners component
 * @extends {React.PureComponent<IHosports2ColumnBannersProps<IHosports2ColumnBannersData>>}
 */
class Hosports2ColumnBanners extends React.PureComponent<IHosports2ColumnBannersProps<IHosports2ColumnBannersData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default Hosports2ColumnBanners;
